import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FromIdeaToShelf from "./sections/FromIdeaToShelf";
import SubscriptionPlans from "./sections/SubscriptionPlans";
import LearningPathways from "./sections/LearningPathways";
import EquipaggiamentoPro from "./sections/EquipaggiamentoPro";
import PartnerOpinions from "./sections/PartnerOpinions";
import ConexaoImediata from "./sections/ConexaoImediata";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FromIdeaToShelf />
      <SubscriptionPlans />
      <LearningPathways />
      <EquipaggiamentoPro />
      <PartnerOpinions />
      <ConexaoImediata />
      <Footer />
    </div>;
}